/**
 * returns number representing font size proportional to width and height of container
 *
 * @memberOf Common.Utils.Styles
 *
 * @param width: {number} the width of the container
 * @param height: {number} the height of the container
 * @returns {number}
 */
export const getProportionalFontSize = (width, height) => {
  const minSize = 10;
  const maxSize = 40;
  const area = width * height;
  const minFont = Math.max(Math.round(Math.sqrt(area) / 23), minSize);
  // keep in between min and max sizes
  return Math.min(minFont, maxSize);
};

/**
 * returns variant based on tile/display item size, used for 'custom' template
 *
 * @memberOf Common.Utils.Styles
 *
 * @param width: {number} the width of item container
 * @param height: {number} the height of items container
 * @returns {string} 's', 'm', 'l'
 */
export const getVariantByTileSize = (width, height) => {
  const area = width * height;
  switch (true) {
    case area < 40000:
      return 'xs';
    case area < 80000:
      return 's';
    case area < 650000:
      return 'm';
    default:
      return 'l';
  }
};

export const viewports = {
  MOBILE_WIDTH: 520,
};
